import React from 'react';
import Icon from '../../../components/AppIcon';

const SentimentAnalysis = ({ data }) => {
  const totalFeedback = data?.reduce((sum, item) => sum + item?.count, 0);

  const getSentimentIcon = (sentiment) => {
    switch (sentiment) {
      case 'positive':
        return { name: 'SmilePlus', color: 'text-success' };
      case 'neutral':
        return { name: 'Meh', color: 'text-warning' };
      case 'negative':
        return { name: 'Frown', color: 'text-error' };
      default:
        return { name: 'MessageCircle', color: 'text-muted-foreground' };
    }
  };

  const getSentimentColor = (sentiment) => {
    switch (sentiment) {
      case 'positive':
        return 'bg-success';
      case 'neutral':
        return 'bg-warning';
      case 'negative':
        return 'bg-error';
      default:
        return 'bg-muted';
    }
  };

  return (
    <div className="card h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">User Sentiment</h3>
        <Icon name="MessageSquare" size={20} className="text-primary" />
      </div>
      <div className="space-y-4 mb-6">
        {data?.map((item) => {
          const percentage = ((item?.count / totalFeedback) * 100)?.toFixed(1);
          const icon = getSentimentIcon(item?.sentiment);

          return (
            <div key={item?.sentiment}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Icon name={icon?.name} size={16} className={icon?.color} />
                  <span className="text-sm font-medium text-foreground capitalize">
                    {item?.sentiment}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-data font-semibold text-foreground">
                    {item?.count?.toLocaleString()}
                  </span>
                  <span className="text-xs text-muted-foreground caption">
                    ({percentage}%)
                  </span>
                </div>
              </div>
              <div className="h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full ${getSentimentColor(item?.sentiment)} transition-all duration-500`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-1">
              Key Insight
            </h4>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Positive sentiment increased by 12% after the latest feature release. Users particularly appreciate the improved swap interface and faster transaction processing.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4">
        <div className="text-center p-3 bg-muted/20 rounded-lg">
          <div className="text-xs text-muted-foreground caption mb-1">Avg. Rating</div>
          <div className="text-2xl font-bold text-foreground font-data">4.6</div>
          <div className="flex items-center justify-center gap-1 mt-1">
            {[1, 2, 3, 4, 5]?.map((star) => (
              <Icon
                key={star}
                name="Star"
                size={12}
                className={star <= 4.6 ? 'text-warning fill-warning' : 'text-muted'}
              />
            ))}
          </div>
        </div>
        <div className="text-center p-3 bg-muted/20 rounded-lg">
          <div className="text-xs text-muted-foreground caption mb-1">Total Reviews</div>
          <div className="text-2xl font-bold text-foreground font-data">
            {totalFeedback?.toLocaleString()}
          </div>
          <div className="text-xs text-success mt-1">+23% this month</div>
        </div>
      </div>
    </div>
  );
};

export default SentimentAnalysis;